import React, { FC } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import HighchartsMore from "highcharts/highcharts-more";
import CommonService from "../../services/common.service";
import { Table } from "antd";
import moment from "moment";

HighchartsMore(Highcharts);

const getBubbleOptions = (data: any) => {
  return {
    chart: {
      type: "packedbubble",
    },
    title: {
      text:
        data?.list?.length > 0
          ? `VOLUMES FOR ${moment(data?.date).format("MM/DD/YYYY")}`
          : `NO DATA FOR ${moment(data?.date).format("MM/DD/YYYY")}`,
    },
    tooltip: {
      useHTML: true,
      formatter: function () {
        const th: any = this;
        return `${th.key}: $${CommonService.toLocalNum(th.y)}`;
      },
    },
    plotOptions: {
      packedbubble: {
        minSize: "70%",
        maxSize: "480%",
        layoutAlgorithm: {
          splitSeries: false,
          gravitationalConstant: 0.02,
        },
        dataLabels: {
          enabled: true,
          format: "{point.name}",
          filter: {
            property: "y",
            operator: ">",
            value: 1000000000,
          },
          style: {
            color: "black",
            textOutline: "none",
            fontWeight: "normal",
          },
        },
      },
    },
    series: data?.list?.map((el: any) => ({
      name: el?.name,
      data: [
        {
          name: el?.name,
          value: el?.volume24h,
        },
      ],
    })),
  };
};

const columns = [
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
    width: "50%",
  },
  {
    title: "24H Volume",
    dataIndex: "volume24h",
    key: "volume",
    render: (text: number) => CommonService.toLocalNum(text),
  },
];

interface IProps {
  data: {
    list: any[];
  };
}

const TradingVolumesTab: FC<IProps> = ({ data }) => {
  return (
    <>
      <HighchartsReact
        highcharts={Highcharts}
        options={getBubbleOptions(data)}
      />
      <Table
        size="small"
        columns={columns}
        dataSource={data?.list || []}
        pagination={false}
        rowKey="id"
      />
    </>
  );
};

export default TradingVolumesTab;
